"use strict";

// NumberHelper
module.exports = {
	roundToTwoDecimals: function(value) {
		return parseFloat(Math.round(this.toNumber(value) + 'e2') + 'e-2')
	},

	roundToOneDecimal: function(value) {
		return parseFloat(Math.round(this.toNumber(value) + 'e1') + 'e-1')
	},

	toNumber: function(value) {
		return +value || 0;
	}
};
